import { render, staticRenderFns } from "./DataSyncTask.vue?vue&type=template&id=3d54ae48"
import script from "./DataSyncTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSyncTask.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports